import { PROYECT } from "services/api";
import { reportSalesTypes } from "redux/reducers/Reports/reportSales/types";
import { saveAs } from 'file-saver';
import axios from "axios";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";
const { SET_REPORT_SALES_FILTERS } = reportSalesTypes


export const getReportSalesUnitAction = ({ startDate, endDate, station, unit, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    const auth = { headers: { authorization: token } };
    const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/settlements/report-sales-per-unit/${unit?.id}?idStation=${station?.id}&initDate=${startDate}&endDate=${endDate}&pdf=${isPdf}`;
    const fileName = `Reporte_Ventas_${station?.name}_Unidad_${unit?.label}_${startDate}_${endDate}.${isPdf ? `pdf` : 'xlsx'}`;

    dispatch(startRequestComp('loadingReportSales'))
    if(!unit?.id || !station?.name){
    dispatch(setSnackbar('Seleccione una unidad'))
    dispatch(stopRequestComp('loadingReportSales'))
    return
  }
    const access = {
      url: reportUrl,
      method: 'GET',
      responseType: 'blob',
      ...auth
    }
    try {
      const pdf = await axios(access)
      saveAs(pdf.data, fileName)
      dispatch(setSnackbar(`${isPdf ? `PDF` : `Excel`} Descargado con éxito`, "success"))
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)))
    } finally {
      dispatch(stopRequestComp('loadingReportSales'))
    }
  }
}

export const getReportSalesAction = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    if (!station?.id || !station?.name) {
      dispatch(setSnackbar('Seleccione una estación'))
      return
    }
    dispatch(startRequestComp('loadingReportSales'))
    const auth = { headers: { authorization: token } };
    const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/settlements/report-sales-by-zone/${station.id}?initDate=${startDate}&endDate=${endDate}&pdf=${isPdf}`;
    const fileName = `Reporte_Ventas_Zona_${station.name}_${startDate}_${endDate}.${isPdf ? `pdf` : 'xlsx'}`;
    const access = {
      url: reportUrl,
      method: 'GET',
      responseType: 'blob',
      ...auth
    }
    try {
      const pdf = await axios(access)
      saveAs(pdf.data, fileName)
      dispatch(setSnackbar(`${isPdf ? `PDF` : `Excel`} Descargado con éxito`, "success"))
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)))
    } finally {
      dispatch(stopRequestComp('loadingReportSales'))
    }
  }
}

export const setReportSalesFilters = (key = "", value) => {
  return {
    type: SET_REPORT_SALES_FILTERS,
    payload: { value, key }
  }
}
